import React, { } from 'react'
import { View, TextInput, Text, TouchableOpacity, } from 'react-native'
import { useSelector } from 'react-redux'
import { IStores } from '../../state/store'

interface IInputProps {
  value?: string,
  placeholder?: string,
  icon?: string,
  onChange?: (value: string) => void,
}
function Input({ value, placeholder, onChange, }: IInputProps) {
  const systemStore = useSelector((state: IStores) => state.systemStore)
  const { mobile, } = systemStore
  const { Colors, Fonts, Spacing, } = systemStore.mobile ? systemStore.Mobile : systemStore.Desktop

  return (
    <>
      <View style={{flexDirection: 'row', justifyContent: 'center', alignItems: 'center', borderWidth: 3, borderColor: Colors.lightBlue, backgroundColor: Colors.safeLightestBackground, borderRadius: 24, padding: Spacing.paddingSm, paddingHorizontal: Spacing.paddingMd,}}>
        <View style={{flex: 1,}}>
          <TextInput
            value={value}
            placeholder={placeholder}
            numberOfLines={1}
            style={{fontSize: Fonts.lg, fontWeight: Fonts.cruiserWeight, color: !value?.length ? Colors.lightGrey : Colors.darkGrey,}}
            onChangeText={value => onChange?.(value)}
          />

        </View>

        {!!value && value.length > 0 &&
          <TouchableOpacity
            style={{flex: 0, justifyContent: 'center', alignItems: 'center', paddingHorizontal: Spacing.paddingSm,}}
            onPress={() => onChange?.('')}
          >
            <Text style={{fontSize: Fonts.md, fontWeight: Fonts.heavyWeight, color: Colors.black,}}>✗</Text>
          </TouchableOpacity>
        }
      </View>
    </>
  )
}

export default Input
